var _circle, _line, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEvWithCharger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 49,
    x2: 35,
    y2: 70,
    stroke: "url(#paint0_linear_5447_24634)",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.7174C20 11.8049 20.7397 11.0652 21.6522 11.0652H34.8696H48.087C48.9994 11.0652 49.7391 11.8049 49.7391 12.7174V50.7337C49.7391 51.4603 49.2645 52.1015 48.5698 52.3138L35.3524 56.3525C35.0377 56.4486 34.7015 56.4486 34.3868 56.3525L21.1694 52.3138C20.4746 52.1015 20 51.4602 20 50.7337V12.7174Z",
    fill: "url(#paint1_linear_5447_24634)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4911 46.9679C32.5804 46.446 32.6696 45.9241 32.7813 45.4249C33.1161 43.9954 33.4509 42.5659 33.7857 41.1591C33.875 40.8187 33.9643 40.4783 34.0312 40.138C34.1205 39.6161 34.0312 39.5026 33.4955 39.5026C31.5089 39.5026 29.5 39.5026 27.5134 39.5026C27.3571 39.5026 27.2009 39.4799 27 39.3892C30.0804 35.2141 33.2277 31.107 36.3527 27C36.3973 27.0227 36.442 27.0227 36.5089 27.0454C36.4643 27.3631 36.4643 27.6807 36.3973 27.9984C36.1518 29.2237 35.8616 30.4263 35.6161 31.6516C35.4375 32.5366 35.3036 33.4215 35.1473 34.2838C35.0804 34.6922 35.1473 34.8056 35.6161 34.8056C36.9777 34.8056 38.3616 34.8056 39.7232 34.8056C40.3482 34.8056 40.9732 34.8056 41.5982 34.8056C41.7321 34.8056 41.8661 34.8964 42 34.9418C41.9554 35.0552 41.9107 35.2141 41.8214 35.3048C40.1473 37.4378 38.4732 39.5707 36.7991 41.7036C35.5714 43.2693 34.3437 44.8577 33.0937 46.4233C32.9375 46.6275 32.7589 46.8091 32.6027 46.9906C32.558 47.0133 32.5134 46.9906 32.4911 46.9679Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5447_24634",
    x1: 31.4894,
    y1: 49,
    x2: 31.4894,
    y2: 69.0651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED560E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89C15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5447_24634",
    x1: 20,
    y1: 34.2659,
    x2: 48.4151,
    y2: 34.2659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED560E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89C15"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvWithCharger);
export default __webpack_public_path__ + "static/media/icon-ev-with-charger.d1e9637ec6292d1859156a08996d3a3c.svg";
export { ForwardRef as ReactComponent };